import ReactDOM from 'react-dom/client'
import App from "./components/App/App"

const root = ReactDOM.createRoot(document.querySelector('#root'))
root.render(<App/>)
